module.exports = __webpack_public_path__ + "img/bumi-kini.1a2d669c.jpg";